<template>
    <alert-item-styled
        :class="isRemove && 'close'"
        :style="`top: ${top(index)}px`"
        :type="type"
        @mouseover="mouseOverHandler"
        @mouseleave="mouseLeaveHandler"
    >
        <div class="alert-message">
            <div class="alert-icon">
                <awesome-icon :name="icon" />
            </div>
            <span v-html="message" />
        </div>
        <div class="alert-close-button" @click="alertCloseHandler">
            <awesome-icon name="times" />
        </div>
    </alert-item-styled>
</template>
<script>
import styled, { css, keyframes } from "vue-styled-components";

const Animate = keyframes`
    100% {
        opacity: 1;
        transform: translateX(-50%);
    } 0% {
        opacity: 0;
        transform: translateX(calc(-50% - 80px));
    }
`;

const CloseAnimate = keyframes`
    100% {
        opacity: 0;
        transform: translateX(calc(-50% + 80px));
    } 0% {
        opacity: 1;
        transform: translateX(-50%);
    }
`;

const AlertItemStyled = styled("div", { type: String })`
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 40rem;
    height: 4.8rem;
    font-size: 1.4rem;
    border-radius: 5px;
    box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.05);
    padding-right: 2.4rem;
    padding-left: 0.4rem;
    border: 1px solid;
    user-select: none;

    animation: ${Animate} 0.3s ease-out backwards;
    opacity: 1;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.3s;

    .alert-message {
        display: flex;
        align-items: center;
        margin-right: 3.6rem;

        .alert-icon {
            width: 4.8rem;
            height: 4.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &.close {
        opacity: 0;
        transform: translateX(-50% + 80px);
        animation: ${CloseAnimate} 0.25s ease-in backwards;
    }

    .alert-close-button {
        cursor: pointer;
    }

    ${props => {
        switch (props.type) {
            case "error":
                return css`
                    color: #ffffff;
                    background-color: ${props => props.theme.color.red};
                    border-color: ${props => props.theme.color.red};
                `;
            case "success":
                return css`
                    color: #ffffff;
                    background-color: ${props => props.theme.color.green};
                    border-color: ${props => props.theme.color.green};
                `;
            case "info":
                return css`
                    color: #ffffff;
                    background-color: ${props => props.theme.color.blue};
                    border-color: ${props => props.theme.color.blue};
                `;
            case "warning":
                return css`
                    color: #ffffff;
                    background-color: ${props => props.theme.color.primary};
                    border-color: ${props => props.theme.color.primary};
                `;
            default:
                return css`
                    background-color: #ffffff;
                    color: #242424;
                    border-color: ${props => props.theme.color.border};
                `;
        }
    }};
`;

export default {
    name: "AlertBanner",
    data: () => ({
        isRemove: false,
        timer: null
    }),
    props: {
        index: Number,
        message: String,
        type: String,
        uid: String,
        icon: String
    },
    computed: {
        top() {
            return index => {
                return index * 48 + index * 10;
            };
        }
    },
    methods: {
        alertCloseHandler() {
            this.timer = null;
            this.isRemove = true;

            setTimeout(() => {
                this.$emit("alert-close", this.uid);
            }, 300);
        },

        closeReservationHandler() {
            if (this.timer === null) {
                this.timer = setTimeout(() => {
                    this.alertCloseHandler();
                }, 3000);
            }
        },

        removeCloseReservationHandler() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },

        mouseOverHandler() {
            this.removeCloseReservationHandler();
        },

        mouseLeaveHandler() {
            this.closeReservationHandler();
        }
    },
    mounted() {
        this.closeReservationHandler();
    },
    components: {
        AlertItemStyled
    }
};
</script>
